module.exports = __webpack_public_path__ + "static/media/icon_assistant_header.921f30a4.svg";